module.exports = __webpack_public_path__ + "static/img/icon_lianbaxz_moren.de8d7484.png";